const formManipulationJquery = window.jQuery;

if (formManipulationJquery) {
    (function ($) {
        let activeDateFilterTimeout = null;

        $(document)
            .on('change', '[data-wp-trigger]', function () {
                clearTimeout(activeDateFilterTimeout);

                const $el = $(this); // ← zachytit referenci mimo setTimeout

                activeDateFilterTimeout = setTimeout(function () {
                    const $target = $($el.data('wp-target'));
                    const trigger = $el.data('wp-trigger');
                    $target.trigger(trigger);
                }, 800);
            })
            .on('click', '[data-wp-toggle="input-change"]', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();

                var $element = $(this);
                var $target = $($element.data('wp-target'));
                var values = $element.data('wp-value');

                if (!values || !$target.length) return;

                Object.entries(values).forEach(([name, value]) => {
                    const $input = $target.find(`[name="${name}"]`);
                    if (!$input.length) return;

                    $input.val(value);
                    $input.attr('value', value);

                    if ($input.is(':radio') || $input.is(':checkbox')) {
                        $input.prop('checked', true);
                    }

                    if ($input.hasClass('tom-select')) {
                        let select_id = $input.attr('id');
                        let select = document.getElementById(select_id);
                        let control = select.tomselect;
                        control.setValue(value, false);
                    }
                });

                $target.trigger('submit');
            });
    })(formManipulationJquery);
} else {
    console.warn('[form-manipulation] jQuery is not available, skipping bindings.');
}
